__webpack_require__.p = "/dm-icon-color/onboarding/";